/**
 * isWindow tells if a provided window ref is a popup or iframe
 * @param {object} winRef reference of the window object
 * @return {boolean} true: if it's a popup, false: if an iframe
 * Ref: https://codereview.stackexchange.com/questions/10346/most-accurate-iswindow-function
 */
function isWindow(winRef) {
  return winRef.top === winRef.self && winRef.top !== undefined;
}

export default isWindow;
